import { useContext } from "react";

import { AppContext } from "../stores";

export const useSelectedLanguage = () => {
  const { state } = useContext(AppContext);
  return state.selectedLanguage;
};
